// extracted by mini-css-extract-plugin
module.exports = {"copyright":"Footer_copyright__2OWH4","footer":"Footer_footer__1w0lV","bgChange":"Footer_bgChange__ZeoTH","container":"Footer_container__st7Zp"};